import dayjs from 'dayjs';
import { startCase } from 'lodash-es';

import { Invoice } from '~hooks/useInvoices/models';
import { getLargestDeliveredQuantitySum } from '~utils/jobs/job-utils';

type InvoiceCsvRow = {
  Driver: string;
  Vendor: string;
  Truck: string;
  'Truck Type': string;
  'Driver Start': string;
  'Driver Stop': string;
  'Total Hours': string;
  'Loads Completed': string;
  'Loads Requested': string;
  'Ticket Qty': string;
  'Ticket Unit': string;
  'Ticket Count': string;
  'Rate Value': string;
  'Rate Type': string;
  'Total Add-On Value': string;
  Total: string;
  'Invoice Status': string;
};

export function transformInvoicesToCSV(invoices: Invoice[]): InvoiceCsvRow[] {
  return invoices.map((invoice) => {
    const totalMinutes =
      invoice.jobSummary?.approvedWorkTimeMinutes ?? invoice.jobSummary?.workTimeMinutes;
    const totalHours =
      totalMinutes !== null && totalMinutes !== undefined
        ? (totalMinutes / 60).toFixed(2)
        : '';

    const { total: deliveredTotal, unitOfMeasure: deliveredUoM } =
      getLargestDeliveredQuantitySum(invoice.jobSummary?.deliveredQuantities ?? []);

    return {
      Driver: invoice.job?.driver?.fullName ?? invoice.driver?.fullName ?? '',
      Vendor: invoice.job?.vendorJobAssignment?.vendorAccount?.name ?? '',
      Truck: invoice.equipment?.name || invoice.equipment?.externalId || '',
      'Truck Type': invoice.equipmentTypeNames?.join(', ') ?? '',
      'Driver Start': invoice.payStartTime
        ? dayjs(invoice.payStartTime).format('YYYY-MM-DD HH:mm:ss')
        : '',
      'Driver Stop': invoice.payEndTime
        ? dayjs(invoice.payEndTime).format('YYYY-MM-DD HH:mm:ss')
        : '',
      'Total Hours': totalHours,
      'Loads Completed': String(invoice.jobSummary?.completedLoadsCount ?? 0),
      'Loads Requested': String(invoice.job?.loadsCount ?? 0),
      'Ticket Qty': deliveredTotal > 0 ? deliveredTotal.toFixed(2) : '',
      'Ticket Unit': deliveredUoM ? startCase(deliveredUoM) : '',
      'Ticket Count': String(invoice.ticketsCount ?? 0),
      'Rate Value':
        invoice.rateValue !== null && invoice.rateValue !== undefined
          ? String(invoice.rateValue)
          : '',
      'Rate Type': invoice.rateType || '',
      'Total Add-On Value': String(invoice.addOnChargesTotalAmount ?? 0),
      Total: String(invoice.totalAmount ?? 0),
      'Invoice Status': invoice.state || '',
    };
  });
}
